//@flow

import parse from "html-react-parser";
import DOMPurify from "dompurify";

import { PROVIDER_IS_NOT_IN_LIST } from "Commons/Modules/Provider/misc/Constants";
import type { ChangeServiceT } from "modules/ChangeService/misc/Types.js";

export const read = (text: string) => {
  if (text) {
    return parse(DOMPurify.sanitize(text));
  } else {
    console.error("The current key is not available in your translation file.");
    return "";
  }
};

export const readAndReplace = (text: string, replaceObject: Object) => {
  if (text) {
    return parse(DOMPurify.sanitize(text), replaceObject);
  } else {
    console.error("The current key is not available in your translation file.");
    return "";
  }
};

export const scrollToFormTop = (offset: number = 0) => {
  const mainLayout = document.getElementById("mainLayout");
  const csFormContainer = document.getElementById("csFormContainer");
  // $FlowFixMe
  const distance = csFormContainer.getBoundingClientRect().top + mainLayout?.scrollTop - offset;

  if (mainLayout) {
    try {
      mainLayout.scroll({ left: 0, top: distance, behavior: "smooth" });
    } catch (err) {
      mainLayout.scrollTop = distance;
      mainLayout.scrollLeft = 0;
    }
  }
};

export const normalizeData = (data: any): ChangeServiceT => {
  const result = { ...data };

  // remove unnecessary keys
  delete result.consumptionChoice;
  delete result.yearlyConsumption;
  delete result.cancelOldContract;
  delete result.canceledMyselfDateDay;
  delete result.canceledMyselfDateMonth;
  delete result.canceledMyselfDateYear;
  delete result.desiredProviderChangeDateDay;
  delete result.desiredProviderChangeDateMonth;
  delete result.desiredProviderChangeDateYear;
  delete result.birthDay;
  delete result.birthMonth;
  delete result.birthYear;

  // provider not in list case
  if (data.categoryProviderId === PROVIDER_IS_NOT_IN_LIST) {
    delete result.categoryProviderId;
    delete result.currentProviderName;
    delete result.permanentTariffId;
    delete result.currentTariff;
    delete result.currentTariffName;
  } else {
    delete result.comment;
  }

  // value correction
  if (data.ecoEnergy === "YES_ECO_TARIFF") {
    result.ecoEnergy = true;
  } else {
    result.ecoEnergy = false;
  }

  if (data.switchProviderOrMove !== "SWITCH_PROVIDER") {
    result.switchProviderOrMove = "MOVE";
    result.expectedConsumption = data.yearlyConsumption;
    result.futureCounterNumber = data.counterNumber;
    delete result.currentConsumption;
    delete result.counterNumber;
  } else {
    result.currentConsumption = data.yearlyConsumption;
    delete result.expectedConsumption;
    delete result.futureCounterNumber;
  }

  result.billingAddressSameAsDeliveryAddress =
    typeof data.billingAddressSameAsDeliveryAddress === "string"
      ? data.billingAddressSameAsDeliveryAddress === "true"
      : data.billingAddressSameAsDeliveryAddress;

  if (data.hasCustomerData === "false") {
    delete result.customerNumber;
    delete result.counterNumber;
    delete result.futureCounterNumber;
  }

  if (data.cancelOldContract === "NEXT_POSSIBLE_DATE") {
    result.switchTariffDateType = "NEXT_POSSIBLE_DATE";
  } else if (data.cancelOldContract === "CUSTOM_SWITCHING_DATE") {
    result.switchTariffDateType = "CUSTOM_SWITCHING_DATE";
  } else {
    result.switchTariffDateType = "NONE";
  }

  if (data.cancelOldContract === "CANCELLED_ALREADY") {
    result.cancellationContractType = "CANCELLED_ALREADY";
  } else {
    result.cancellationContractType = "AUTOMATIC_CANCELLATION";
  }

  if (data.accountOwnerType === "IMPORT_FROM_DELIVERY_ADDRESS") {
    delete result.differentAccountHolderSalutation;
    delete result.differentAccountHolderSalutationTitle;
    delete result.differentAccountHolderFirstname;
    delete result.differentAccountHolderLastname;
    delete result.differentAccountHolderPostalcode;
    delete result.differentAccountHolderLocationId;
    delete result.differentAccountHolderLocation;
    delete result.differentAccountHolderLocationMainName;
    delete result.differentAccountHolderLocationPartName;
    delete result.differentAccountHolderStreet;
    delete result.differentAccountHolderStreetNumber;
  }

  /* Valid phone number property */
  if (result.cellPhoneNumber) {
    result.formattedE164PhoneNumber = "+49" + result.cellPhoneNumber;
    delete result.cellPhoneNumber;
  }

  return result;
};
